@defer (when !isLoading()) {
  <wcg-grid-page>
    <wcg-grid-table
      lockArxis="x"
      orientation="horizontal"
      [isLoading]="isLoading()!"
      [gridData]="gridData()!"
      [gridColumns]="gridColumns()!"
      [displayColumns]="gColumns()!"
      [enableFixedLayout]="true"
      [noDataMessage]="noDataMessage()"
      [actionHeaderTemplateRef]="actionHeaderTemplateRef()"
      [actionTemplateRef]="actionTemplateRef()"
      [addressesTemplateRef]="addressesTemplateRef()"
      [tasksTemplateRef]="tasksTemplateRef()"
      [chipTemplateRef]="chipTemplateRef()"
      [gridViewsTemplateRef]="gridViewsTemplateRef()"
      [gridFeatureTemplateRef]="gridFeatureTemplateRef()"
      [selectTemplateRef]="selectTemplateRef()"
      [checkBoxTemplateRef]="checkBoxTemplateRef()"
      [resetSort]="$resetSort()!"
      [disableDragDrop]="disableDragAndDrop()!"
      (handleSortChange)="handleSortEvent($event)"
      (handleDrop)="handleDropChange($event)"
    />
    <!--    ADVANCED FILTERS-->
    <!--    @TODO NEED TO UPDATE DATA MAPPING FOR ADVANCED FILTERS-->
    @if (enableAdvanceFilters()) {
      <ng-container ngProjectAs="advanced-filters">
        <div class="relative">
          @let advancedFiltersLength =
            (advancedFilters() | keyvalue)?.length || 0;
          @if (enableFilterComponent() && advancedFiltersLength > 0) {
            <wcg-ui-filter-wrapper
              [advancedFiltersFormGroup]="advancedFiltersFormGroup!"
              [advancedFilters]="advancedFilters()!"
              [appliedFilters]="appliedFilters()!"
              [gridViewData]="gridViewData()"
              (applyFilters)="applyFilters($event)"
              (removeFilter)="removeFilter($event)"
              (clearFilters)="clearFilters()"
              (revertGridState)="onRevertGridState()"
            />
          }
        </div>

        <!--    BULK ACTIONS-->
        @if (bulkActionsTemplateRef()) {
          <div class="relative flex">
            <ng-container *ngTemplateOutlet="bulkActionsTemplateRef()!" />
          </div>
        }
        <!--    BULK ACTIONS END-->
      </ng-container>
    }
    <!--    ADVANCED FILTERS END-->

    <!--    GRID FEATURE WRAPPER-->
    <wcg-grid-feature-wrapper>
      <form [formGroup]="searchFieldForm" novalidate>
        <div class="flex gap-4">
          @if (enableManageColumn()) {
            <mat-icon
              class="mt-6 cursor-pointer"
              fontSet="material-icons-outlined"
              (click)="manageColumns.emit()"
              >settings</mat-icon
            >
          }
          @if (enableSearch()) {
            <wcg-input-field
              [formControl]="searchFieldForm.controls.searchString"
              (keydown.enter)="handleSearchEvent($event)"
              (handleIconAction)="handleSearchEvent()"
              placeholder="Search"
              iconText="search"
            />
          }
          @if (enableSegmentedToggle()) {
            <wcg-ui-grid-toggle-group
              [options]="toggleGroupOptions()"
              [value]="selectedToggle()"
              (valueChange)="selectToggle.emit($event)"
            />
          }
          <wcg-grid-actions
            [apiURL]="apiURL()"
            [wcgTableValues]="wcgTableValues()"
            [canExport]="gridFeatures().canExportAll"
            [canDelete]="canBulkDelete()"
            [canDownload]="gridFeatures().canDownloadAll"
            [deleteBtnLabel]="deleteBtnLabel()"
            [selectedRows]="selectedRows()"
            [canBulkEdit]="canBulkEdit()"
            [studyId]="studyId()"
            [entityId]="entityId()"
            [entityType]="entityType()"
            [isOutcome]="isOutcome()"
            [exportArgs]="exportArgs()"
            (delete)="delete.emit()"
            (resetSelectedRows)="resetSelectedRows.emit()"
            (bulkEdit)="bulkEdit.emit()"
          />
        </div>
      </form>
    </wcg-grid-feature-wrapper>
    <!--        GRID FEATURE WRAPPER End-->
    <!--        GRID VIEWS WRAPPER-->

    @if (enableGridView()) {
      <wcg-grid-views-wrapper class="mt-2">
        <wcg-grid-view-drop-down />
      </wcg-grid-views-wrapper>
    }

    <!--        GRID VIEWS WRAPPER END-->

    <wcg-pagination
      [pageSizeOptions]="paginationOptions()!"
      (changes)="handlePageEvent($event)"
      [pageSize]="pageView().pageSize"
      [pageIndex]="pageView().page"
      [length]="totalCount()!"
    />
  </wcg-grid-page>
} @placeholder {
  <div
    class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
  >
    <mat-spinner data-testId="ui-grid-wrapper__spinner" />
  </div>
}

<ng-template #dragHandler>
  <mat-icon class="drag-indicator">drag_indicator</mat-icon>
</ng-template>
<ng-template
  #hyperLinkRef
  let-routerLink="routerLink"
  let-routerValue="routerValue"
>
  <a [routerLink]="routerLink">
    {{ routerValue }}
  </a>
</ng-template>
